import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { Add as AddIcon } from '@mui/icons-material';
import { SearchBar, TasksTable } from './components';
import { GlobalButton, NavigateLinks } from '@/components';
import { GlobalButtonVariant } from '@/components/buttons/GlobalButton';
import { tasksPageBreadcrumbs } from './config';
import { useTasksFilter } from './hooks';
import { TaskFilter } from './interfaces';

export const Tasks = () => {
  const navigate = useNavigate();
  const breadcrumbs = useMemo(() => tasksPageBreadcrumbs(navigate), []);

  const { filter, initialFilter, setFilter } = useTasksFilter();

  return (
    <section className='flex flex-col gap-6 w-full h-full'>
      <NavigateLinks actualPage='Tareas' breadcrumbs={breadcrumbs} />
      <div className='flex justify-end gap-2.5'>
        <GlobalButton
          variant={GlobalButtonVariant.primaryButton}
          action={() => navigate('/tasks/create')}
        >
          <AddIcon />
          Agregar tarea
        </GlobalButton>
      </div>
      <SearchBar
        filter={filter}
        initialFilter={initialFilter}
        search={(updatedFilter: TaskFilter) => setFilter(updatedFilter)}
      />
      <TasksTable filter={filter} />
    </section>
  );
};
